var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 111,
    viewBox: "0 0 115 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 23.2513C4 24.3559 4.89543 25.2513 6 25.2513C7.10457 25.2513 8 24.3559 8 23.2513H4ZM6 2V0H4V2H6ZM25.178 4C26.2826 4 27.178 3.10457 27.178 2C27.178 0.895431 26.2826 0 25.178 0V4ZM89.4503 0C88.3457 0 87.4503 0.895431 87.4503 2C87.4503 3.10457 88.3457 4 89.4503 4V0ZM108.628 2H110.628V0H108.628V2ZM106.628 23.2513C106.628 24.3559 107.524 25.2513 108.628 25.2513C109.733 25.2513 110.628 24.3559 110.628 23.2513H106.628ZM110.628 80.7853C110.628 79.6808 109.733 78.7853 108.628 78.7853C107.524 78.7853 106.628 79.6808 106.628 80.7853H110.628ZM108.628 101V103H110.628V101H108.628ZM89.4503 99C88.3457 99 87.4503 99.8954 87.4503 101C87.4503 102.105 88.3457 103 89.4503 103V99ZM25.178 103C26.2826 103 27.178 102.105 27.178 101C27.178 99.8954 26.2826 99 25.178 99V103ZM6 101H4V103H6V101ZM8 80.7853C8 79.6808 7.10457 78.7853 6 78.7853C4.89543 78.7853 4 79.6808 4 80.7853H8ZM17.4031 13.4031V11.4031H15.4031V13.4031H17.4031ZM17.4031 39.8377H15.4031V41.8377H17.4031V39.8377ZM46.4293 39.8377V41.8377H48.4293V39.8377H46.4293ZM46.4293 13.4031H48.4293V11.4031H46.4293V13.4031ZM17.4031 62.1257V60.1257H15.4031V62.1257H17.4031ZM46.4293 62.1257H48.4293V60.1257H46.4293V62.1257ZM46.4293 90.1152V92.1152H48.4293V90.1152H46.4293ZM17.4031 90.1152H15.4031V92.1152H17.4031V90.1152ZM68.7173 13.4031V11.4031H66.7173V13.4031H68.7173ZM96.7068 13.4031H98.7068V11.4031H96.7068V13.4031ZM96.7068 39.8377V41.8377H98.7068V39.8377H96.7068ZM68.7173 39.8377H66.7173V41.8377H68.7173V39.8377ZM59.4607 67.3089V69.3089H63.4607V67.3089H59.4607ZM61.4607 59.534V57.534H59.4607V59.534H61.4607ZM74.4188 59.534H76.4188V57.534H74.4188V59.534ZM72.4188 67.3089V69.3089H76.4188V67.3089H72.4188ZM89.4503 57.534H87.4503V61.534H89.4503V57.534ZM96.7068 61.534H98.7068V57.534H96.7068V61.534ZM96.7068 70.8639H98.7068V66.8639H96.7068V70.8639ZM83.2304 68.8639V66.8639H81.2304V68.8639H83.2304ZM81.2304 80.7853V82.7853H85.2304V80.7853H81.2304ZM98.7068 78.712V76.712H94.7068V78.712H98.7068ZM96.7068 90.1152V92.1152H98.7068V90.1152H96.7068ZM83.2304 88.1152H81.2304V92.1152H83.2304V88.1152ZM68.7173 92.1152H70.7173V88.1152H68.7173V92.1152ZM61.4607 88.1152H59.4607V92.1152H61.4607V88.1152ZM61.4607 78.7853H59.4607V82.7853H61.4607V78.7853ZM68.7173 80.7853V82.7853H70.7173V80.7853H68.7173ZM70.7173 68.8639V66.8639H66.7173V68.8639H70.7173ZM76.4188 76V74H72.4188V76H76.4188ZM72.4188 90.1152V92.1152H76.4188V90.1152H72.4188ZM8 23.2513V2H4V23.2513H8ZM6 4H25.178V0H6V4ZM89.4503 4H108.628V0H89.4503V4ZM106.628 2V23.2513H110.628V2H106.628ZM106.628 80.7853V101H110.628V80.7853H106.628ZM108.628 99H89.4503V103H108.628V99ZM25.178 99H6V103H25.178V99ZM8 101V80.7853H4V101H8ZM15.4031 13.4031V39.8377H19.4031V13.4031H15.4031ZM17.4031 41.8377H46.4293V37.8377H17.4031V41.8377ZM48.4293 39.8377V13.4031H44.4293V39.8377H48.4293ZM46.4293 11.4031H17.4031V15.4031H46.4293V11.4031ZM17.4031 64.1257H46.4293V60.1257H17.4031V64.1257ZM44.4293 62.1257V90.1152H48.4293V62.1257H44.4293ZM46.4293 88.1152H17.4031V92.1152H46.4293V88.1152ZM19.4031 90.1152V62.1257H15.4031V90.1152H19.4031ZM68.7173 15.4031H96.7068V11.4031H68.7173V15.4031ZM94.7068 13.4031V39.8377H98.7068V13.4031H94.7068ZM96.7068 37.8377H68.7173V41.8377H96.7068V37.8377ZM70.7173 39.8377V13.4031H66.7173V39.8377H70.7173ZM63.4607 67.3089V59.534H59.4607V67.3089H63.4607ZM61.4607 61.534H74.4188V57.534H61.4607V61.534ZM72.4188 59.534V67.3089H76.4188V59.534H72.4188ZM89.4503 61.534H96.7068V57.534H89.4503V61.534ZM96.7068 66.8639H83.2304V70.8639H96.7068V66.8639ZM94.7068 78.712V90.1152H98.7068V78.712H94.7068ZM96.7068 88.1152H83.2304V92.1152H96.7068V88.1152ZM68.7173 88.1152H61.4607V92.1152H68.7173V88.1152ZM61.4607 82.7853H68.7173V78.7853H61.4607V82.7853ZM70.7173 80.7853V68.8639H66.7173V80.7853H70.7173ZM81.2304 68.8639V74.8246H85.2304V68.8639H81.2304ZM81.2304 74.8246V80.7853H85.2304V74.8246H81.2304ZM72.4188 76V90.1152H76.4188V76H72.4188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2881,
    y: 23.2515,
    width: 7.25654,
    height: 7.25654,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.084,
    y: 22.2148,
    width: 7.25654,
    height: 7.25654,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2881,
    y: 73.0107,
    width: 7.25654,
    height: 7.25654,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_12",
    x: 0,
    y: 0,
    width: 114.628,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_12",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scan-icon.4b0b1d228b5480ddd3f0a0b0581374ba.svg";
export { ForwardRef as ReactComponent };